import React from 'react';
import styled from 'styled-components';

/**
 * Container for header content above the auth card
 */
export const AuthHeader = styled.div`
    padding: 30px 0 10px 0;
`;
